/**
 *
 * Common form classNames for BP Faktoriya(14419)
 *
 */

export const helperTextClassName = 'BP_Faktoriya-14419-advanced-form-field-helper-text';
